import React from "react";
import {connect} from "react-redux";

import {ModelportfolioList} from "../../../Modelportfolios";
import {executeIfPathExist, getInvestmentDynamicPath} from "../../../InvestmentPlatform/utils";
import {openInNewTab} from "../../../../utils/utils";
import {SERVER_ERROR} from "../../../../utils/constants";
import {ModelPortfolioResource} from "../../../../utils/api";
import {displayErrorSnackBar} from "../../../../components/SnackbarProvider/actions";
import MPExternalDepotModal from "./components/MPExternalDepotModal";


const MusterdepotsSelection = (props) => {
  const {
    dispatch,
    investmentPlatform,
    addMusterdepotModalOpen,
    handleAddMusterdepotClose,
    customerId,
    refresh,
  } = props;

  const [selectedMusterdepot, setSelectedMusterdepot] = React.useState(undefined);
  const [addMusterdepotInProgress, setAddMusterdepotInProgress] = React.useState(false);

  const handleSave = () => {
    setAddMusterdepotInProgress(true);
    ModelPortfolioResource.cloneToCustomer(selectedMusterdepot.id, customerId, {
      name: selectedMusterdepot.name,
      extra_fields: selectedMusterdepot.extra_fields
    })
      .then(refresh)
      .catch(() => {
        dispatch(displayErrorSnackBar(SERVER_ERROR))
      }).finally(() => {
        setAddMusterdepotInProgress(false)
        handleAddMusterdepotClose();
        resetForm();
      });
  }

  const resetForm = () => setSelectedMusterdepot(undefined);

  return (
    <MPExternalDepotModal
      title={'Musterdepots'}
      open={addMusterdepotModalOpen}
      modalLoading={addMusterdepotInProgress}
      handleClose={handleAddMusterdepotClose}
      portfolio={selectedMusterdepot}
      formData={selectedMusterdepot}
      setFormData={setSelectedMusterdepot}
      handleSave={handleSave}
      handleBack={resetForm}
      customClasses={{dialogContent: 'flex noPadding'}}
      onExited={resetForm}
    >
      <ModelportfolioList
        handleEditClick={(item, skipDetails) => {
          if(skipDetails){
            setSelectedMusterdepot({...item});
          } else {
            executeIfPathExist(investmentPlatform.routes, 'MODELPORTFOLIO_OVERVIEW', path => {
              let pathUpdated = path.replace(':id', item.id);

              openInNewTab(`/${getInvestmentDynamicPath()}${pathUpdated}`)
            })
          }
        }}
        viewOnly
        hideDetailsBtn
        title={null}
      />
    </MPExternalDepotModal>
  )
};

export default connect()(MusterdepotsSelection);